<template>
  <div>
    <!-- Overlay -->
    <transition name="fade">
      <div v-if="props.modelValue" class="overlay" @click="closePanel"></div>
    </transition>

    <!-- Sliding Panel -->
    <transition name="slide">
      <aside v-if="props.modelValue" class="panel">
        <div class="panel-content">
          <slot name="content"></slot>
        </div>
      </aside>
    </transition>
  </div>
</template>

<script setup lang="ts">

const props = defineProps<{
  modelValue: boolean,
  dark: boolean,
  backgroundImageId: string
}>();

const bgImageUrl = computed(() => {
  if (!props.backgroundImageId || !props.backgroundImageId.length) return undefined;
  const url = getImage(props.backgroundImageId);
  return url;
});

const emit = defineEmits<{
  (e: 'update:modelValue', value: boolean): void
}>();

function closePanel() {
  emit('update:modelValue', !props.modelValue);
}

</script>

<style scoped lang="scss">
/* Overlay */
.overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.4);
  z-index: 10;
}

/* Panel */
.panel {
  position: fixed;
  top: 0;
  right: 0;
  min-width: 40vw;
  max-width: 100vw;
  height: 100vh;
  background: var(--white-color);
  box-shadow: -2px 0 8px rgba(0, 0, 0, 0.2);
  z-index: 20;
  display: flex;
  flex-direction: column;
}

.panel-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem;
}

.panel-content {
  //padding: 40px;
  height: 100%;

  &.dark {
    color: white;
    background-color: rgba(0, 0, 0, 0.95);
  }
}

/* Transitions */
.slide-enter-active,
.slide-leave-active {
  transition: transform 0.3s ease;
}

.slide-enter-from,
.slide-leave-to {
  transform: translateX(100%);
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
